import React from 'react'
import { Table, TableCell, TableRow } from '@chilecompra/react-kit/components'
import { REACT_APP_MP_URL } from '../../config/settings/environment'
import AboutSiteNavButton from '../../components/Navigation/AboutSiteNavButton'
import {
  Description,
  GridContainer,
  GridItem,
  Item,
  List,
  Link,
  Root,
  Strong,
  Subtitle,
  Title
} from './AboutDefinitionsSection.styles'

/**
 * The AboutDefinitionsSection's container.
 */
const AboutDefinitionsSection = () => {
  return (
    <Root>
      <GridContainer padding="0 0 26px">
        <AboutSiteNavButton />
        <GridItem xs={10} sm={11}>
          <Title>Definiciones</Title>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 26px">
        <GridItem xs={12}>
          <Description>
            Dentro del sitio de Datos Abiertos de ChileCompra encontrarás palabras o definiciones técnicas propias del
            proceso de compras públicas que realizan los organismos públicos en{' '}
            <Link href={REACT_APP_MP_URL}>www.mercadopublico.cl</Link>. A continuación, podrás revisar el significado de
            cada una de éstas.
          </Description>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 30px">
        <GridItem xs={12}>
          <Subtitle>Estado de las órdenes de compra</Subtitle>
          <Description>
            Corresponden a los distintos estados en los que se encuentran las órdenes de compra que se descargan y se
            utilizan para construir las cifras que se informan en el sitio de Datos Abiertos.
          </Description>
        </GridItem>
        <GridItem xs={12} margin="32px 0 0">
          <Table>
            <TableRow enableHead>
              <TableCell>ID</TableCell>
              <TableCell width="35%">Estado de la orden de compra</TableCell>
              <TableCell>Definición</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>4</TableCell>
              <TableCell>Enviada a proveedor</TableCell>
              <TableCell>El comprador público envía la orden de compra al proveedor.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>5</TableCell>
              <TableCell>En proceso</TableCell>
              <TableCell>La orden compra enviada todavía no es aceptada por el proveedor.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>6</TableCell>
              <TableCell>Aceptada</TableCell>
              <TableCell>El proveedor aceptó la orden de compra enviada por el comprador.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>7</TableCell>
              <TableCell>Solicitud de cancelación</TableCell>
              <TableCell>El proveedor solicita la cancelación de la orden de compra.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>12</TableCell>
              <TableCell>Recepción conforme</TableCell>
              <TableCell>
                El comprador indica a través de la plataforma que recibió a conformidad los bienes o servicios por parte
                del proveedor.
              </TableCell>
            </TableRow>
          </Table>
        </GridItem>
        <GridItem xs={12} margin="32px 0 0">
          <Subtitle>Estado de licitaciones</Subtitle>
          <Description>
            Corresponden a los distintos estados en los que se encuentran las licitaciones que se descargan desde el
            sitio de Datos Abiertos.
          </Description>
        </GridItem>
        <GridItem xs={12} margin="32px 0 0">
          <Table>
            <TableRow enableHead>
              <TableCell>ID</TableCell>
              <TableCell>Estado de la licitación</TableCell>
              <TableCell width="60%">Definición</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>5</TableCell>
              <TableCell>Publicada</TableCell>
              <TableCell>
                Es una licitación respecto de la cual la respectiva entidad ha realizado el llamado a propuesta pública,
                mediante la publicación de las bases en <Link href={REACT_APP_MP_URL}>www.mercadopublico.cl</Link>. A
                partir de ese momento se podrán recibir ofertas a través de la plataforma. Cabe señalar que durante esta
                etapa las bases pueden ser modificadas, mediante el correspondiente acto administrativo, el que debe
                publicarse oportunamente en el sistema.
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>6, 11, 12, 13, 14</TableCell>
              <TableCell>Cerrada</TableCell>
              <TableCell>
                Es aquella licitación respecto de la que ya se ha cumplido el plazo para el cierre de recepción de
                ofertas y se ha practicado la apertura de las respectivas ofertas. Durante esta etapa las ofertas son
                sometidas al proceso de evaluación por parte de la respectiva entidad licitante.
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>7</TableCell>
              <TableCell>Desierta</TableCell>
              <TableCell>
                Es aquella licitación en la que no se han presentado ofertas, o bien, éstas no resultaron convenientes a
                sus intereses. En ambos casos la declaración deberá ser por resolución fundada.
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>8, 9, 10</TableCell>
              <TableCell>Adjudicada</TableCell>
              <TableCell>
                Es una licitación respecto de la cual ya se ha emitido la resolución de adjudicación, seleccionando al o
                los proveedores mejor evaluados.
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>15</TableCell>
              <TableCell>Revocada</TableCell>
              <TableCell>
                Es un proceso que se deja sin efecto. Este acto debe formalizarse por resolución fundada antes de la
                adjudicación.
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>16</TableCell>
              <TableCell>Suspendida</TableCell>
              <TableCell>
                Es aquella licitación cuya tramitación ha sido suspendida por disponerlo así el Tribunal de Contratación
                Pública mediante una resolución judicial. La licitación puede ser suspendida en cualquier momento,
                durante el período que va desde la publicación de las bases hasta la adjudicación.
              </TableCell>
            </TableRow>
          </Table>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 32px">
        <GridItem xs={12}>
          <Subtitle>Procedimientos de compra</Subtitle>
          <Description>
            Los organismos del Estado regidos por la ley N° 19.886 realizan sus adquisiciones a través de 4 mecanismos
            de compra:
          </Description>
          <List>
            <Item>
              <Strong>Tienda Convenio Marco</Strong>: Es un catálogo electrónico de productos y servicios altamente
              demandados por el Estado siendo la primera opción de compra que los organismos públicos deben consultar
              antes de hacer una licitación. Esta tienda está formada por proveedores adjudicados que participaron de
              una licitación pública de Convenio Marco, realizada por la Dirección ChileCompra.
            </Item>
            <Item>
              <Strong>Licitación pública</Strong>: Es un llamado público, abierto y competitivo que realizan los
              organismos del Estado en <Link href={REACT_APP_MP_URL}>www.mercadopublico.cl</Link>, si es que no
              encuentran el producto o servicio en la tienda de convenios marco. Sujetándose a las bases de licitación
              respectivas, los proveedores formulan propuestas, de entre las cuales se realiza una evaluación para la
              selección y aceptación de la más conveniente.
            </Item>
            <Item>
              <Strong>Licitación privada</Strong>: En este caso el llamado a participar es específico a algunas empresas
              o personas, estableciéndose en esta invitación a un mínimo de tres proveedores del rubro. Una vez
              finalizado el plazo para presentar la oferta, se adjudica el proceso a quien entregó las mejores
              condiciones.
            </Item>
            <Item>
              <Strong>Trato Directo</Strong>: Procedimiento excepcional de contratación, con causales particulares
              establecidas en la normativa de compras públicas, para seleccionar a un proveedor, sin un llamado público
              a participar. Según la normativa de compras públicas, es necesario un acto administrativo fundado que
              apruebe su procedencia y, en la mayoría de los casos, se requiere de tres cotizaciones.
            </Item>
          </List>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 32px">
        <GridItem xs={12}>
          <Subtitle>Modalidades de compra</Subtitle>
          <Description>
            Los organismos del Estado regidos por la ley N° 19.886 realizan sus adquisiciones a través de 4 mecanismos
            de compra:
          </Description>
          <List>
            <Item>
              <Strong>Compra Ágil</Strong>: En el contexto del Plan Económico de Emergencia asociado al Coronavirus que
              fue anunciado el 2020 por el Ministro de Hacienda, ChileCompra habilitó el 2020 en{' '}
              <Link href={REACT_APP_MP_URL}>www.mercadopublico.cl</Link>
              la modalidad Compra Ágil que permitió abrir el mercado para rubros y proveedores de todo el país,
              especialmente micro y pequeños, al permitir un acceso competitivo, rápido y flexible a oportunidades de
              negocio de montos menores a 30 UTM.
              <br />
              <br />
              Esta herramienta permite a los proveedores acceder a nuevas oportunidades de negocio, específicamente a
              compras menores a 30 UTM (aprox. 1,5 millones de pesos), de manera fácil y simple, ya que los organismos
              públicos pueden realizar estas adquisiciones vía la plataforma transaccional{' '}
              <Link href={REACT_APP_MP_URL}>www.mercadopublico.cl</Link>, otorgando mayor transparencia y competitividad
              a estos procesos.
            </Item>
            <Item>
              <Strong>Bases Tipo de Licitación</Strong>: Esta nueva modalidad de licitación pública permite ahorros de
              tiempo en los plazos de gestión y mayor facilidad para ofertar ya que sus aspectos administrativos son
              estandarizados y ya fueron tomados de razón por parte de la Contraloría General de la República.
              <List>
                <Item>
                  El comprador puede concentrarse –exclusivamente– en los aspectos técnicos de la compra, adaptando las
                  bases de licitación a sus necesidades, sin incurrir en todos los costos administrativos que implica
                  realizar una licitación (entre ellos, el trámite de la Toma de Razón de las bases). Puede personalizar
                  las bases y reutilizarlas para diversos procesos, ahorrando costos y tiempos administrativos: posee
                  mayor flexibilidad para contratar cursos con modalidades y temáticas más vigentes, con apoyo en nuevas
                  plataformas tecnológicas de aprendizaje o metodologías actuales y a la medida de la necesidad del
                  organismo público.
                </Item>
                <Item>
                  En tanto, el proveedor puede incrementar las oportunidades de negocio a las que puede postular pues se
                  enfrenta a aspectos formales administrativos estandarizados, sin importar qué institución esté
                  realizando la compra, lo que permitirá que los costos de realizar una oferta bajen significativamente.
                  Según se señala en el “Estudio de Mercado sobre Compras Públicas” de la Fiscalía Nacional Económica de
                  noviembre de 2020, las Bases Tipo son un mecanismo que fomenta una mayor eficiencia y probidad,
                  permitiendo una mayor estandarización, lo que redunda en aumentar la competencia en las licitaciones,
                  y disminuir el sobrecosto administrativo.
                </Item>
                <Item>
                  <Strong>Compras Coordinadas</Strong>: Esta modalidad de compra se adecúa a los estándares de
                  organismos multilaterales y aplica a compras donde dos o más organismos pueden agregar demanda para
                  obtener condiciones más ventajosas. Estas licitaciones públicas pueden ser realizadas por ChileCompra
                  en forma mandatada o por los organismos con asesoría de ChileCompra. Permite, gracias a la agregación
                  de demanda de los organismos, aprovechar economías de escala y lograr un mejor uso de los recursos
                  públicos al obtener ahorros en precios y reducir los costos por transacción.
                </Item>
              </List>
            </Item>
          </List>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 32px">
        <GridItem xs={12}>
          <Subtitle>Formato de datos</Subtitle>
          <Description>
            El formato de los archivos descargables corresponden a archivos CSV, en UTF-8, y campos separados por punto
            y coma (;).
          </Description>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 32px">
        <GridItem xs={12}>
          <Subtitle>Proveedores del Estado</Subtitle>
          <Description>
            Corresponden a personas naturales o jurídicas que transan en Mercado Público, es decir que envían sus
            ofertas y/o reciben órdenes de compra en los últimos 12 meses.
          </Description>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 32px">
        <GridItem xs={12}>
          <Subtitle>Reclamos</Subtitle>
          <Description>
            ChileCompra ofrece un canal de reclamos por no pago oportuno, los que son derivados a las instituciones
            involucradas para que apuren sus pagos. También los proveedores pueden acceder al formulario de reclamo
            directamente desde la ficha de licitación de un organismo.
            <br />
            <br />
            Los organismos tienen 2 días hábiles para responder el reclamo.
          </Description>
        </GridItem>
      </GridContainer>
    </Root>
  )
}

export default AboutDefinitionsSection
